module.exports = __webpack_public_path__ + "static/img/アセット 13@2x.d20e158.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/meal_entry/アセット 13@2x.png
// module id = MasD
// module chunks = 1